module.exports = __webpack_public_path__ + "static/offer-fizjoteriapia-image-2-b21f2d216bc1f397900522b14d8ac9d8.png";